import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Teachers from './pages/Teachers';
import Students from './pages/Students';
import Resources from './pages/Resources';
import CardGame from './pages/CardGame';
import ElectoralGame from './pages/ElectoralGame';
import WordSearch from './pages/WordSearch';
//import NotFound from './pages/NotFound';
import './index.css';
import './fonts.css';
import ScreenSizeIndicator from './components/BreakpointIndicator';

function App() {
  // Set the base path to match your environment
  const basename = '/elections/projectvote';

  // Function to handle "Skip to main content"
  const handleSkipToContent = (e) => {
    e.preventDefault(); // Prevent default link behavior
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus(); // Move focus to the main content
      mainContent.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll to main content
    }
  };

  return (
    <Router basename={basename}>
      {/* Use a Fragment to make sure the structure stays intact */}
      <>
        {/* Skip to Main Content Link */}
        <a href="#main-content" className="sr-only focus:not-sr-only text-white" onClick={handleSkipToContent}>
          Skip to main content
        </a>

        {/* Navigation should appear first */}
        <Navigation />
        
        {/* Wrap Routes in a main element with an ID */}
        <main id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/index.html" element={<Home />} />
            <Route path="/teachers" element={<Teachers />} />
            <Route path="/students" element={<Students />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/cardgame" element={<CardGame />} />
            <Route path="/electoralgame" element={<ElectoralGame />} />
            <Route path="/wordsearch" element={<WordSearch />} />
            <Route path="*" element={<Navigate to="/index.html" />} />
          </Routes>
        </main>

        {/* Footer at the bottom */}
        <Footer />
        {process.env.NODE_ENV === 'development' && <ScreenSizeIndicator />}
      </>
    </Router>
  );
}

export default App;
